import AccountSettings from "@/pages/(app)/account-settings/page.tsx";
import CustomerPortalPage from "@/pages/(app)/customer-portal/page";
import EmbedLayout from "@/pages/(app)/embed/layout.tsx";
import EmbedPage from "@/pages/(app)/embed/page.tsx";
import IntegrationsPage from "@/pages/(app)/integrations/page";
import AdminLayout from "@/pages/(app)/admin/layout";
import AdminPage from "@/pages/(app)/admin/page";
import AppLayout from "@/pages/(app)/layout";
import ReturnLayout from "@/pages/(app)/returns/view/layout.tsx";
import ReturnPage from "@/pages/(app)/returns/view/page";
import ShopLayout from "@/pages/(app)/shop/layout";
import AuthLayout from "@/pages/(auth)/layout.tsx";
import SignInPage from "@/pages/(auth)/sign-in/page.tsx";
import SignUpPage from "@/pages/(auth)/sign-up/page.tsx";
import SignUpSuccessPage from "@/pages/(auth)/sign-up-success/page.tsx";
import VerifyEmailPage from "@/pages/(auth)/verify-email/page.tsx";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ShopSettingsPage from "./components/shop-informations-settings-form/shop-settings";
import WorkflowLayout from "./pages/(app)/automations/layout";
import WorkflowsPage from "./pages/(app)/automations/page";
import WorkflowEditFlows from "./pages/(app)/automations/workflow/page";
import PageBillings from "./pages/(app)/billings/page";
import GiftCodes from "./pages/(app)/gift-codes";
import Home from "./pages/(app)/home";
import ReturnsLayout from "./pages/(app)/returns/layout";
import ReturnsPage from "./pages/(app)/returns/list/page";
import ShopsPage from "./pages/(app)/shops/page";
import ForgotPassword from "./pages/(auth)/forgot-password";
import Carriers from "./pages/carriers/carriers";
import AutologinPage from "./pages/(app)/autologin/autologin";
import { ResetPassword } from "./pages/(auth)/reset-password/page";
import { SettingsLayout } from "./components/settings-layout";
import AskPage from "./pages/(app)/ask/ask-page";
import OperationalDashboard from "./pages/(app)/operational-dashboard";
import ForceLogout from "./pages/(auth)/force-logout";
import GorgiasConnectPage from "./pages/gorgias/connect/page";
import AnalyticsLayout from "./pages/(app)/analytics/layout";
import AnalyticsPage from "./pages/(app)/analytics";
import SizingPage from "./pages/(app)/analytics/sizing";
import SizingSimulatorPage from "./pages/(app)/sizing/simulator";
import SizingInstallPage from "./pages/(app)/sizing/install";
import AlertsSettingsPage from "./pages/(app)/settings-alerts/page";
import CustomerUiDemoPage from "./pages/customer-ui-demo";
import { ReturnWidgetLayout } from "./pages/return-widget/components/layout";
import { ReturnWidgetOrderIdentification } from "./pages/return-widget/components/order-identification";
import { LineItemLayout } from "./pages/return-widget/components/line-item/layout";
import { Reason } from "./pages/return-widget/components/line-item/reason";
import { Resolution } from "./pages/return-widget/components/line-item/resolution";
import { ResolutionOptions } from "./pages/return-widget/components/line-item/resolution-options";
import { LineItemSelection } from "./pages/return-widget/components/line-item/line-item-selection";
import { ReturnRequestsList } from "./pages/return-widget/components/return-requests/return-requests-list";
import { ReturnRequestDetails } from "./pages/return-widget/components/return-requests/details";
import { ReturnRequestsLayout } from "./pages/return-widget/components/return-requests/layout";
import { LineItemConfirmation } from "./pages/return-widget/components/line-item/confirmation";
import { ReturnRequestSummary } from "./pages/return-widget/components/summary";
import { ReturnMode } from "./pages/return-widget/components/return-mode";
import {
  RetractationArticleSelectionPage,
  RetractationSummaryPage,
} from "@babackapp/return-widget-components";
import { ReturnWidgetAddressCheck } from "./pages/return-widget/components/address-check";
import { Checkout } from "./pages/return-widget/components/checkout";
import { ReturnRequestComplete } from "./pages/return-widget/components/complete";

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/force-logout" element={<ForceLogout />} />
        <Route path="/autologin" element={<AutologinPage />} />
        <Route path="/gorgias/connect" element={<GorgiasConnectPage />} />
        <Route
          path="/login"
          element={<Navigate to="/auth/sign-in" replace />}
        />
        <Route path="/auth" element={<AuthLayout />}>
          <Route path="sign-in" element={<SignInPage />} />
          <Route path="sign-up" element={<SignUpPage />} />
          <Route path="sign-up-success" element={<SignUpSuccessPage />} />
          <Route path="verify-email" element={<VerifyEmailPage />} />
          <Route path="forgotpassword" element={<ForgotPassword />} />
          <Route path="resetpassword" element={<ResetPassword />} />
        </Route>
        <Route path="o" element={<EmbedLayout />}>
          <Route index element={<EmbedPage />} />
        </Route>
        <Route path="/" element={<AppLayout />} loader>
          <Route index element={<ShopsPage />} />
          <Route path="admin" element={<AdminLayout />}>
            <Route index element={<AdminPage />} />
          </Route>
          <Route path={"shops/:shopId"} element={<ShopLayout />}>
            <Route index element={<Home />} />
            <Route path={"operations"} element={<WorkflowLayout />}>
              <Route index element={<OperationalDashboard />} />
            </Route>
            <Route path={"workflows"} element={<WorkflowLayout />}>
              <Route index element={<WorkflowsPage />} />
              <Route path={":workflowId"} element={<WorkflowEditFlows />} />
            </Route>

            <Route path={"returns"} element={<ReturnsLayout />}>
              <Route index element={<ReturnsPage />} />
              <Route path={":returnId"} element={<ReturnLayout />}>
                <Route index element={<ReturnPage />} />
              </Route>
            </Route>
            <Route path={"analytics"} element={<AnalyticsLayout />}>
              <Route index element={<AnalyticsPage />} />
            </Route>
            <Route path={"sizing"}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<SizingPage />} />
              <Route path="simulator" element={<SizingSimulatorPage />} />
              <Route path="install" element={<SizingInstallPage />} />
            </Route>
            <Route path={"ask"} element={<AskPage />} />
            <Route path="gift-codes" element={<GiftCodes />} />
            <Route path={"settings"} element={<SettingsLayout />}>
              <Route
                path="shop-informations"
                element={<ShopSettingsPage />}
                index
              />
              <Route path="customer-portal" element={<CustomerPortalPage />} />

              {["integrations", "integrations/stripe"].map((r) => (
                <Route key={r} path={r} element={<IntegrationsPage />} />
              ))}
              <Route path="carriers" element={<Carriers />} />
              <Route path="billing" element={<PageBillings />} />
              <Route path="alerts" element={<AlertsSettingsPage />} />
              <Route path="gift-codes" element={<div>Gift Code</div>} />
            </Route>

            <Route path={"account/settings"} element={<AccountSettings />} />
          </Route>
        </Route>
        <Route path="/customer-ui-demo" element={<CustomerUiDemoPage />} />
        <Route path="/return-widget/:shopId" element={<ReturnWidgetLayout />}>
          <Route index element={<ReturnWidgetOrderIdentification />} />
          <Route path="order/:orderId">
            <Route path="return-mode" element={<ReturnMode />} />
            <Route
              path="retractation-article-selection"
              element={<RetractationArticleSelectionPage />}
            />
            <Route
              path="retractation-summary"
              element={<RetractationSummaryPage />}
            />
            <Route path="return-requests" element={<ReturnRequestsLayout />}>
              <Route index element={<ReturnRequestsList />} />
              <Route
                path=":returnRequestId"
                element={<ReturnRequestDetails />}
              />
            </Route>
            <Route path="summary" element={<ReturnRequestSummary />} />
            <Route path="address" element={<ReturnWidgetAddressCheck />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="complete" element={<ReturnRequestComplete />} />
            <Route path="line-item" element={<LineItemLayout />}>
              <Route index element={<LineItemSelection />} />
              <Route path=":lineItemId">
                <Route path="reason" element={<Reason />} />
                <Route path="resolution" element={<Resolution />} />
                <Route
                  path="resolution-options"
                  element={<ResolutionOptions />}
                />
                <Route path="confirmation" element={<LineItemConfirmation />} />
              </Route>
            </Route>
          </Route>
        </Route>
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}
